import Page from "../../components/layout/Page";
import { connect } from "react-redux";
import Util from "../../util";
import { Dropdown, Menu } from "antd";
import Links from "../../navigation/Links";
import {
  DownOutlined,
} from "@ant-design/icons";
import TableView from "../../components/TableView";
import { clearCache, deleteBundle, getBundles } from "../../redux/activity-bundles/actions";
import BundleDialog from "./BundleDialog";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { useState } from "react";

const TableColumns = ({ onItemClick, onDelete } = {}) => [
  {
    title: "Id",
    dataIndex: "id",
    fixed: "left",
  },
  {
    title: "Name",
    dataIndex: "name",
    ellipsis: true,
  },
  {
    title: "Date created",
    render: (item) => Util.formatDate(item.date_created),
  },
  {
    title: "Date updated",
    render: (item) => Util.formatDate(item.date_updated),
  },
  {
    title: "Action",
    key: "action",
    width: 180,
    fixed: "right",
    render: (word) => (
      <span className="table-action-buttons">
        <div className="text-button mr-10" onClick={() => onItemClick(word)}>
          View
        </div>
        <Dropdown
          trigger={["click"]}
          className="table-more-button cursor-pointer"
          overlay={
            <Menu className="actions-menu">
              <Menu.Item className="negative" onClick={() => onDelete(word)}>
                Delete
              </Menu.Item>
            </Menu>
          }
        >
          <span className="text-button ant-dropdown-link">
            More <DownOutlined />
          </span>
        </Dropdown>
      </span>
    ),
  },
];

function Bundles({ getBundles, deleteBundle, clearCache }) {

  return (
    <Page title="QnA Activity Bundles">
      <TableView
        title="QnA Activity Bundles"
        columns={TableColumns}
        getItems={getBundles}
        deleteItem={deleteBundle}
        addButton={{ text: "Add Activity Bundle" }}
        searchLabel="Search Activity Bundle Name"
        Dialog={BundleDialog}
        getLink={(s) => (s ? Links.Activity_bundle(s) : Links.ACTIVITY_BUNDLES)}
      />
    </Page>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getBundles: (...args) => dispatch(getBundles(...args)),
  deleteBundle: (...args) => dispatch(deleteBundle(...args)),
  clearCache: (...args) => dispatch(clearCache(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Bundles);
